import Loading from "@components/layout/Loading";
import { AspectRatio, Box } from "@mantine/core";
import { useGetUser } from "@utils/hooks";
import { Link } from "react-router-dom";
import ApprovedCelebrationIllustration from "../../assets/illustrations/scheduled_call.png";

const Celebration = () => {
  const { isLoading } = useGetUser();

  if (isLoading) return <Loading />;

  return (
    <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[416px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
        <div className="flex flex-col w-full md:overflow-hidden">
          <Box className="w-full relative overflow-hidden">
            <img
              src={ApprovedCelebrationIllustration}
              alt="Request followup"
              className="object-cover w-full"
            />
            <div className="absolute top-[47%] left-0 right-0 w-full">
              <AspectRatio ratio={16 / 9}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="42"
                  viewBox="0 0 375 42"
                  fill="none"
                >
                  <path
                    d="M75.399 331.369C250.199 298.993 335.857 123.093 536.034 63.155L530.95 35.5147C323.374 75.8681 158.833 -32.7349 -6.24216 11.1731C-72.968 31.1529 -107.019 73.6584 -122.139 125.995C-146.564 210.537 -99.1907 302.739 -18.8191 325.958C9.31538 334.087 43.7863 335.321 75.399 331.369Z"
                    fill="#F8F7F3"
                  />
                </svg>
              </AspectRatio>
            </div>
          </Box>

          <div className="flex flex-col gap-y-4 py-4 px-4 md:px-6">
            <span className="text-pn-large-title text-pn_gray-950">
              It's all done! <br /> Celebrate in style.
            </span>
            <span className="text-pn-body-regular !font-normal text-pn_gray-600">
              Sit back, relax and we will soon contact you with more details
            </span>
          </div>

          <div className="px-4 my-[32px] w-full">
            <Link to={"/"} className="btn-primary-lg text-center w-full block">
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Celebration;
